// @flow
import React from 'react';

type Translations = {|
  birch: {|
    dropdowns: {|
      no_results: string,
      create_item: string,
      error_loading_results: string,
    |},
  |},
|};

const defaultTranslations: Translations = {
  birch: {
    dropdowns: {
      no_results: 'No results found',
      create_item: 'Create',
      error_loading_results: 'There was an error loading results',
    },
  },
};

const TranslationsContext =
  React.createContext<Translations>(defaultTranslations);

export default TranslationsContext;
